module.exports = __webpack_public_path__ + "img/logo_gluu_bizconnect_red.24654acd.png";